import React from 'react';
import ChamadoClienteList from './chamadoClienteList';

const ChamadosClient: React.FC = () => {
  return <ChamadoClienteList />;
};

export default ChamadosClient; 
